"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _padStart = _interopRequireDefault(require("lodash/padStart"));

var parseColorValue = function parseColorValue(colorValue, percentageTotal) {
  return colorValue.endsWith("%") ? percentageTotal * (parseFloat(colorValue) / 100) : parseFloat(colorValue);
};
/**
 * Convert a CSS rgb (or rgba) color string into a tuple containing a plain hex
 * color and an opacity (from 0 to 1).
 */


function cssRgbToHex(cssRgb) {
  var match = cssRgb.match(/rgba?\((.*)\)/);

  if (match) {
    var _match$1$split = match[1].split(","),
        _match$1$split2 = (0, _slicedToArray2["default"])(_match$1$split, 4),
        r = _match$1$split2[0],
        g = _match$1$split2[1],
        b = _match$1$split2[2],
        a = _match$1$split2[3];

    return ["#" + (0, _padStart["default"])(parseColorValue(r, 255).toString(16), 2, "0") + (0, _padStart["default"])(parseColorValue(g, 255).toString(16), 2, "0") + (0, _padStart["default"])(parseColorValue(b, 255).toString(16), 2, "0"), a ? parseColorValue(a, 1) : 1];
  } else {
    return [];
  }
}

var _default = cssRgbToHex;
exports["default"] = _default;